<template>
  <Modal
    :title="modalTitle"
    :saving="saving"
    :submit-btn-text="actionButtonText"
    @hide-modal="emit('hide-modal')"
    @submit="requestDeclineQuote"
  >
    <div class="form-group">
      <textarea
        v-model="reason"
        class="form-control"
        :placeholder="reasonPlaceholder"
        name="Reason"
        data-cy="reason"
        rows="5"
        :class="{ 'is-invalid': v$.reason.$error }"
      ></textarea>
      <span v-if="v$.reason.$error" class="text-danger error-text">
        Reason required
      </span>
    </div>
  </Modal>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { useStore } from "vuex";
import { EventBus } from "@/lib/event_bus.js";

import Modal from "@/components/Modal.vue";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";

const emit = defineEmits(["hide-modal"]);
const props = defineProps<{
  quoteData: {
    id: number;
    status: string;
    links: {
      quote_decline: string;
    };
    type: object;
    default: () => {};
  };
}>();

const store = useStore();
const declineQuote = (payload) => store.dispatch("declineQuote", payload);
const setCurrentQuote = (payload) => store.dispatch("setCurrentQuote", payload);

const saving = ref(false);
const reason = ref("");
const rules = {
  reason: { required, $autoDirty: true }
};
const v$ = useVuelidate(rules, { reason });

const modalTitle = computed(() => `Quote #${props.quoteData.id}`);
const isQuoteDenied = computed(() => props.quoteData.status === "denied");
const actionButtonText = computed(() =>
  isQuoteDenied.value ? "Reactivate Quote" : "Decline Quote"
);
const reasonPlaceholder = computed(() =>
  isQuoteDenied.value
    ? "Add a reason quote will be reactivated"
    : "Add a reason quote was declined"
);

const requestDeclineQuote = async () => {
  const valid = await v$.value.$validate();
  if (!valid) return;

  const wasDenied = isQuoteDenied.value;
  const payload = {
    decline_url: props.quoteData.links.quote_decline,
    reason: reason.value
  };

  saving.value = true;
  declineQuote(payload)
    .then(() => {
      saving.value = false;
      const action = wasDenied ? "reactivated" : "declined";
      EventBus.$emit("refresh-quote-datatable");
      window.notify.success(`Quote #${props.quoteData.id} has been ${action}`);
      emit("hide-modal");
      setCurrentQuote(null);
    })
    .catch(() => {
      saving.value = false;
    });
};
</script>

<style lang="scss" scoped></style>
